// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   InputAdornment,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Alert,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Grid,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import {
//   Search,
//   Add,
//   Visibility,
//   Edit,
//   Block,
//   Delete,
//   CheckCircle,
//   Cancel,
//   AccountBalanceWallet,
// } from '@mui/icons-material';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import apiService from '../services/apiService';
// import config from '../config/config';

// const DriversPage = () => {
//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedDriver, setSelectedDriver] = useState(null);
//   const [openAddDialog, setOpenAddDialog] = useState(false);
//   const [regions, setRegions] = useState([]);
//   const [services, setServices] = useState([]);
//   const [driverPhoto, setDriverPhoto] = useState(null);
//   const [driverPhotoPreview, setDriverPhotoPreview] = useState(null);
//   const [editMode, setEditMode] = useState(false);
//   const [editingDriver, setEditingDriver] = useState(null);
//   // URL of the bank-passbook image currently shown in the inline preview
//   // dialog. null means dialog is closed.
//   const [bankImagePreviewUrl, setBankImagePreviewUrl] = useState(null);

//   // Recharge dialog state
//   const [openRechargeDialog, setOpenRechargeDialog] = useState(false);
//   const [rechargeDriver, setRechargeDriver] = useState(null);
//   const [rechargePlans, setRechargePlans] = useState([]);
//   const [selectedPlanId, setSelectedPlanId] = useState('');
//   const [customDays, setCustomDays] = useState('');
//   const [rechargeNotes, setRechargeNotes] = useState('');
//   const [rechargeLoading, setRechargeLoading] = useState(false);
//   const [driverRechargeStatus, setDriverRechargeStatus] = useState(null);

//   const fetchDrivers = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const params = {};
//       if (statusFilter !== 'all') {
//         params.status = statusFilter;
//       }

//       console.log('Fetching drivers with params:', params);
//       const response = await apiService.getDrivers(params);
//       console.log('Drivers response:', response);

//       if (response.success) {
//         const driversData = response.data || [];
//         console.log('Drivers data:', driversData);
//         setDrivers(driversData);
//         setError('');
//       } else {
//         // Empty data is not an error - just set empty array
//         setDrivers([]);
//         setError('');
//       }
//     } catch (err) {
//       console.error('Drivers fetch error:', err);
//       console.error('Error details:', {
//         message: err.message,
//         response: err.response,
//         status: err.response?.status,
//         code: err.code
//       });
//       setDrivers([]);

//       // Check if it's a network error (no response from server)
//       if (!err.response && (err.code === 'ECONNREFUSED' || err.code === 'ERR_NETWORK' || err.message.includes('Network Error'))) {
//         setError(`Unable to connect to backend server. Please ensure the backend is running on ${config.SOCKET_URL}`);
//       } else if (err.response?.status === 404) {
//         // 404 means endpoint not found or no data - don't show error
//         setError('');
//       } else if (err.response?.status === 401) {
//         // Authentication error - will be handled by interceptor
//         setError('');
//       } else if (err.response) {
//         // Other HTTP errors - only show if there's a meaningful error message
//         const errorMessage = err.response.data?.message || err.message;
//         if (errorMessage && !errorMessage.includes('No drivers')) {
//           setError(errorMessage);
//         } else {
//           setError('');
//         }
//       } else {
//         // For any other case (like empty data), don't show error
//         setError('');
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [statusFilter]);

//   const fetchRegions = async () => {
//     try {
//       const response = await apiService.getRegions();
//       if (response.success) {
//         setRegions(response.data.data || response.data);
//       }
//     } catch (err) {
//       console.error('Regions error:', err);
//     }
//   };

//   const fetchServices = async () => {
//     try {
//       const response = await apiService.getServices();
//       console.log('Services Response:', response);
//       if (response.success) {
//         const servicesData = response.data.data || response.data;
//         console.log('Services Data:', servicesData);
//         setServices(servicesData);
//       }
//     } catch (err) {
//       console.error('Services error:', err);
//     }
//   };

//   useEffect(() => {
//     fetchDrivers();
//     fetchRegions();
//     fetchServices();
//   }, [fetchDrivers]);

//   const handleViewDriver = async (driver) => {
//     setSelectedDriver(driver);
//     setOpenDialog(true);
//   };

//   const handleBlockDriver = async (driverId) => {
//     if (!window.confirm('Are you sure you want to block this driver?')) {
//       return;
//     }

//     try {
//       const response = await apiService.blockDriver(driverId, 'Blocked by admin');

//       if (response.success) {
//         alert('Driver blocked successfully');
//         fetchDrivers();
//       } else {
//         alert(response.message || 'Failed to block driver');
//       }
//     } catch (err) {
//       alert('Failed to block driver');
//     }
//   };

//   const handleDeleteDriver = async (driverId) => {
//     if (!window.confirm('Are you sure you want to delete this driver? This action cannot be undone.')) {
//       return;
//     }

//     try {
//       const response = await apiService.deleteDriver(driverId);

//       if (response.success) {
//         alert('Driver deleted successfully');
//         fetchDrivers();
//       } else {
//         alert(response.message || 'Failed to delete driver');
//       }
//     } catch (err) {
//       alert('Failed to delete driver');
//     }
//   };

//   // Recharge handlers
//   const handleOpenRechargeDialog = async (driver) => {
//     setRechargeDriver(driver);
//     setSelectedPlanId('');
//     setCustomDays('');
//     setRechargeNotes('');
//     setOpenRechargeDialog(true);

//     // Fetch recharge plans (filtered by driver's service type) and driver's current recharge status
//     try {
//       const [plansResponse, statusResponse] = await Promise.all([
//         apiService.getAdminRechargePlans(driver.id), // Pass driver ID to filter plans by service
//         apiService.getDriverRechargeStatus(driver.id)
//       ]);

//       if (plansResponse.success) {
//         setRechargePlans(plansResponse.data || []);
//       }

//       if (statusResponse.success) {
//         setDriverRechargeStatus(statusResponse.data);
//       }
//     } catch (err) {
//       console.error('Error fetching recharge data:', err);
//     }
//   };

//   const handleCloseRechargeDialog = () => {
//     setOpenRechargeDialog(false);
//     setRechargeDriver(null);
//     setRechargePlans([]);
//     setSelectedPlanId('');
//     setCustomDays('');
//     setRechargeNotes('');
//     setDriverRechargeStatus(null);
//   };

//   const handleAssignRecharge = async () => {
//     if (!selectedPlanId && !customDays) {
//       alert('Please select a plan or enter custom days');
//       return;
//     }

//     if (customDays && (isNaN(customDays) || parseInt(customDays) < 1)) {
//       alert('Please enter a valid number of days');
//       return;
//     }

//     setRechargeLoading(true);

//     try {
//       const data = {
//         notes: rechargeNotes || 'Assigned by admin'
//       };

//       if (selectedPlanId) {
//         data.planId = selectedPlanId;
//       } else {
//         data.days = parseInt(customDays);
//         data.amount = 0; // Free assignment by admin
//       }

//       const response = await apiService.assignDriverRecharge(rechargeDriver.id, data);

//       if (response.success) {
//         alert(`Recharge assigned successfully! ${response.data?.rechargeDays || customDays} days added.`);
//         handleCloseRechargeDialog();
//         fetchDrivers();
//       } else {
//         alert(response.message || 'Failed to assign recharge');
//       }
//     } catch (err) {
//       console.error('Assign recharge error:', err);
//       alert('Failed to assign recharge');
//     } finally {
//       setRechargeLoading(false);
//     }
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: editMode && editingDriver ? editingDriver.name : '',
//       phone: editMode && editingDriver ? editingDriver.phone : '',
//       gender: editMode && editingDriver ? editingDriver.gender : '',
//       region: editMode && editingDriver ? editingDriver.region_id : '',
//       vehicleType: editMode && editingDriver ? editingDriver.vehicleTypeId : '',
//       vehicleNumber: editMode && editingDriver ? editingDriver.vehicleNumber : '',
//       vehicleModel: editMode && editingDriver ? editingDriver.vehicleModel : '',
//       status: editMode && editingDriver ? editingDriver.status : 'pending',
//     },
//     enableReinitialize: true,
//     validationSchema: Yup.object({
//       name: Yup.string().required('Name is required').min(3, 'Name must be at least 3 characters'),
//       phone: Yup.string()
//         .required('Phone number is required')
//         .matches(/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/im, 'Invalid phone number'),
//       gender: Yup.string().required('Gender is required'),
//       region: Yup.string().required('Region is required'),
//       vehicleType: Yup.string().required('Vehicle Type is required'),
//       vehicleNumber: Yup.string().required('Vehicle Number is required'),
//       vehicleModel: Yup.string().required('Vehicle Model is required'),
//       status: Yup.string().required('Status is required'),
//     }),
//     onSubmit: async (values, { setSubmitting, resetForm }) => {
//       try {
//         let response;

//         if (editMode) {
//           // Edit mode - update driver
//           const updateData = {
//             name: values.name,
//             phone: values.phone,
//             gender: values.gender,
//             region: values.region,
//             vehicleType: values.vehicleType,
//             vehicleNumber: values.vehicleNumber,
//             vehicleModel: values.vehicleModel,
//             status: values.status,
//           };

//           response = await apiService.updateDriver(editingDriver.id, updateData);

//           if (response.success) {
//             alert('Driver updated successfully');
//             setOpenAddDialog(false);
//             setEditMode(false);
//             setEditingDriver(null);
//             resetForm();
//             fetchDrivers();
//           } else {
//             const errorMsg = response.message || response.error?.message || 'Failed to update driver';
//             alert(errorMsg);
//           }
//         } else {
//           // Add mode - validate photo is uploaded
//           if (!driverPhoto) {
//             alert('Please upload a driver photo');
//             setSubmitting(false);
//             return;
//           }

//           // Create FormData for file upload
//           const formData = new FormData();
//           formData.append('name', values.name);
//           formData.append('phone', values.phone);
//           formData.append('gender', values.gender);
//           formData.append('region', values.region);
//           formData.append('vehicleType', values.vehicleType);
//           formData.append('vehicleNumber', values.vehicleNumber);
//           formData.append('vehicleModel', values.vehicleModel);
//           formData.append('status', values.status);
//           formData.append('photo', driverPhoto);

//           console.log('Submitting driver with FormData...');
//           response = await apiService.addDriver(formData);
//           console.log('Add driver response:', response);

//           if (response.success) {
//             alert('Driver added successfully');
//             setOpenAddDialog(false);
//             resetForm();
//             setDriverPhoto(null);
//             setDriverPhotoPreview(null);
//             fetchDrivers();
//           } else {
//             const errorMsg = response.message || response.error?.message || 'Failed to add driver';
//             console.error('Failed to add driver:', errorMsg, response);
//             alert(errorMsg);
//           }
//         }
//       } catch (err) {
//         console.error('Driver operation error:', err);
//         console.error('Error details:', err.response || err);
//         const errorMsg = err.response?.data?.message || err.message || 'Operation failed';
//         alert('Error: ' + errorMsg);
//       } finally {
//         setSubmitting(false);
//       }
//     },
//   });

//   const handleAddDriver = () => {
//     setEditMode(false);
//     setEditingDriver(null);
//     formik.resetForm();
//     setDriverPhoto(null);
//     setDriverPhotoPreview(null);
//     setOpenAddDialog(true);
//   };

//   const handleEditDriver = (driver) => {
//     setEditMode(true);
//     setEditingDriver(driver);
//     setOpenAddDialog(true);
//   };

//   const handleCloseAddDialog = () => {
//     setOpenAddDialog(false);
//     setEditMode(false);
//     setEditingDriver(null);
//     formik.resetForm();
//     setDriverPhoto(null);
//     setDriverPhotoPreview(null);
//   };

//   const handlePhotoChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         alert('Please select an image file');
//         return;
//       }
//       // Validate file size (max 5MB)
//       if (file.size > 5 * 1024 * 1024) {
//         alert('File size should not exceed 5MB');
//         return;
//       }
//       setDriverPhoto(file);
//       // Create preview URL
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setDriverPhotoPreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       active: { label: 'Active', color: 'success' },
//       pending: { label: 'Pending', color: 'warning' },
//       blocked: { label: 'Blocked', color: 'error' },
//       inactive: { label: 'Inactive', color: 'default' },
//     };

//     const config = statusConfig[status] || statusConfig.inactive;
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   const getVerificationChip = (status) => {
//     const statusConfig = {
//       verified: { label: 'Verified', color: 'success', icon: <CheckCircle /> },
//       pending: { label: 'Pending', color: 'warning' },
//       rejected: { label: 'Rejected', color: 'error', icon: <Cancel /> },
//     };

//     const config = statusConfig[status] || statusConfig.pending;
//     return <Chip label={config.label} color={config.color} size="small" icon={config.icon} />;
//   };

//   const columns = [
//     {
//       field: 'profile_photo',
//       headerName: 'Driver Photo',
//       width: 100,
//       renderCell: (params) => {
//         const photoUrl = params.row.profile_photo || params.row.photo;
//         if (!photoUrl) {
//           return (
//             <div style={{
//               width: 50,
//               height: 50,
//               borderRadius: '50%',
//               background: '#FFC107',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: 20,
//               color: '#000',
//             }}>
//               {(params.row.name || 'D').charAt(0).toUpperCase()}
//             </div>
//           );
//         }
        
//         const cleanPath = String(photoUrl).trim().replace(/^\/+/, '');
//         const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
//         const fullUrl = `${baseUrl}/${cleanPath}`;
        
//         return (
//           <img 
//             src={fullUrl} 
//             alt={params.row.name || 'Driver'}
//             style={{
//               width: 50,
//               height: 50,
//               borderRadius: '50%',
//               objectFit: 'cover',
//               border: '2px solid #FFC107',
//             }}
//           />
//         );
//       },
//     },
//     {
//       field: 'name',
//       headerName: 'Driver Name',
//       width: 180,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2" fontWeight={600}>
//             {params.row.name || '-'}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             {params.row.phone}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'vehicleType',
//       headerName: 'Vehicle',
//       width: 150,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2">{params.row.vehicleType}</Typography>
//           <Typography variant="caption" color="text.secondary">
//             {params.row.vehicleNumber}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 120,
//       renderCell: (params) => getStatusChip(params.row.status),
//     },
//     {
//       field: 'verificationStatus',
//       headerName: 'Verification',
//       width: 130,
//       renderCell: (params) => getVerificationChip(params.row.verificationStatus),
//     },
//     {
//       field: 'rating',
//       headerName: 'Rating',
//       width: 100,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           ⭐ {Number(params.row.rating || 0).toFixed(2)}
//         </Typography>
//       ),
//     },
//     {
//       field: 'totalRides',
//       headerName: 'Total Rides',
//       width: 110,
//     },
//     {
//       field: 'isOnline',
//       headerName: 'Online',
//       width: 100,
//       renderCell: (params) => (
//         <Chip
//           label={params.row.isOnline ? 'Online' : 'Offline'}
//           color={params.row.isOnline ? 'success' : 'default'}
//           size="small"
//         />
//       ),
//     },
//     {
//       field: 'walletBalance',
//       headerName: 'Wallet',
//       width: 110,
//       renderCell: (params) => `₹${params.row.walletBalance}`,
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 220,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleViewDriver(params.row)}>
//             <Visibility fontSize="small" />
//           </IconButton>
//           <IconButton
//             size="small"
//             color="primary"
//             onClick={() => handleEditDriver(params.row)}
//           >
//             <Edit fontSize="small" />
//           </IconButton>
//           <IconButton
//             size="small"
//             sx={{ color: '#FF9800' }}
//             onClick={() => handleOpenRechargeDialog(params.row)}
//             title="Assign Recharge"
//           >
//             <AccountBalanceWallet fontSize="small" />
//           </IconButton>
//           {params.row.status !== 'blocked' && (
//             <IconButton
//               size="small"
//               color="error"
//               onClick={() => handleBlockDriver(params.row.id)}
//             >
//               <Block fontSize="small" />
//             </IconButton>
//           )}
//           <IconButton
//             size="small"
//             color="error"
//             onClick={() => handleDeleteDriver(params.row.id)}
//           >
//             <Delete fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   const filteredDrivers = drivers.filter((driver) =>
//     driver.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     driver.phone.includes(searchQuery) ||
//     driver.vehicleNumber.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Drivers
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Manage all driver accounts
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           startIcon={<Add />}
//           onClick={handleAddDriver}
//           sx={{
//             bgcolor: '#FFC107',
//             color: '#000',
//             '&:hover': {
//               bgcolor: '#FFD54F',
//             },
//           }}
//         >
//           Add Driver
//         </Button>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
//             <TextField
//               placeholder="Search by name, phone, or vehicle number..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ flexGrow: 1 }}
//             />
//             <FormControl sx={{ minWidth: 150 }}>
//               <InputLabel>Status</InputLabel>
//               <Select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 label="Status"
//               >
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="active">Active</MenuItem>
//                 <MenuItem value="pending">Pending</MenuItem>
//                 <MenuItem value="blocked">Blocked</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>

//           <DataGrid
//             rows={filteredDrivers}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//             localeText={{
//               noRowsLabel: 'No drivers found. Click "Add Driver" to create your first driver.',
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* View Driver Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>Driver Details</DialogTitle>
//         <DialogContent>
//           {selectedDriver && (
//             <Box sx={{ pt: 2 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Name</Typography>
//                   <Typography variant="body1" fontWeight={600}>{selectedDriver.name}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Phone</Typography>
//                   <Typography variant="body1">{selectedDriver.phone}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Email</Typography>
//                   <Typography variant="body1">{selectedDriver.email}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Vehicle Type</Typography>
//                   <Typography variant="body1">{selectedDriver.vehicleType}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Vehicle Number</Typography>
//                   <Typography variant="body1">{selectedDriver.vehicleNumber}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Status</Typography>
//                   <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedDriver.status)}</Box>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Verification</Typography>
//                   <Box sx={{ mt: 0.5 }}>{getVerificationChip(selectedDriver.verificationStatus)}</Box>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Rating</Typography>
//                   <Typography variant="body1">⭐ {Number(selectedDriver.rating || 0).toFixed(2)}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Total Rides</Typography>
//                   <Typography variant="body1">{selectedDriver.totalRides}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Wallet Balance</Typography>
//                   <Typography variant="body1">₹{selectedDriver.walletBalance}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Subscription Expiry</Typography>
//                   <Typography variant="body1">
//                     {selectedDriver.subscriptionExpiry || 'No active subscription'}
//                   </Typography>
//                 </Grid>

//                 {/* Bank Details (optional — driver may submit this so we can
//                     credit them manually for refunds, fare disputes, etc.) */}
//                 <Grid item xs={12}>
//                   <Box sx={{ mt: 2, mb: 1, pt: 2, borderTop: '1px solid #eee' }}>
//                     <Typography variant="subtitle1" fontWeight={700}>
//                       Bank Details
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Use these to manually credit the driver if needed.
//                     </Typography>
//                   </Box>
//                 </Grid>
//                 {(selectedDriver.bank_account_number || selectedDriver.bankAccountNumber ||
//                   selectedDriver.bank_ifsc_code || selectedDriver.bankIfscCode ||
//                   selectedDriver.bank_account_image || selectedDriver.bankAccountImage) ? (
//                   <>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2" color="text.secondary">Account Number</Typography>
//                       <Typography variant="body1" fontWeight={600}
//                         sx={{ fontFamily: 'monospace', letterSpacing: 0.5 }}>
//                         {selectedDriver.bank_account_number ||
//                           selectedDriver.bankAccountNumber ||
//                           'Not provided'}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography variant="body2" color="text.secondary">IFSC Code</Typography>
//                       <Typography variant="body1" fontWeight={600}
//                         sx={{ fontFamily: 'monospace', letterSpacing: 0.5 }}>
//                         {selectedDriver.bank_ifsc_code ||
//                           selectedDriver.bankIfscCode ||
//                           'Not provided'}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                         Passbook / Cheque Image
//                       </Typography>
//                       {(() => {
//                         const imgPath = selectedDriver.bank_account_image || selectedDriver.bankAccountImage;
//                         if (!imgPath) {
//                           return (
//                             <Typography variant="body2" color="text.secondary">
//                               No image uploaded
//                             </Typography>
//                           );
//                         }
//                         const cleanPath = String(imgPath).trim().replace(/^\/+/, '');
//                         const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
//                         const fullUrl = `${baseUrl}/${cleanPath}`;
//                         return (
//                           <Box
//                             onClick={() => setBankImagePreviewUrl(fullUrl)}
//                             sx={{ display: 'inline-block', cursor: 'pointer' }}
//                           >
//                             {/* Plain <img> tag — Box component="img" was
//                                 rendering broken in some browsers. */}
//                             <img
//                               src={fullUrl}
//                               alt="Bank passbook"
//                               style={{
//                                 maxWidth: 300,
//                                 maxHeight: 200,
//                                 display: 'block',
//                                 borderRadius: 4,
//                                 border: '1px solid #e0e0e0',
//                               }}
//                             />
//                             <Typography variant="caption" display="block"
//                               sx={{ mt: 0.5, color: 'primary.main' }}>
//                               Click to view full-size
//                             </Typography>
//                           </Box>
//                         );
//                       })()}
//                     </Grid>
//                   </>
//                 ) : (
//                   <Grid item xs={12}>
//                     <Typography variant="body2" color="text.secondary"
//                       sx={{ fontStyle: 'italic' }}>
//                       Driver has not provided bank details yet (this is optional).
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Bank Passbook Image Preview Dialog (inline — no new tab) */}
//       <Dialog
//         open={Boolean(bankImagePreviewUrl)}
//         onClose={() => setBankImagePreviewUrl(null)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           Bank Passbook / Cheque
//           <IconButton size="small" onClick={() => setBankImagePreviewUrl(null)}>
//             <Cancel />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {bankImagePreviewUrl && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
//               <img
//                 src={bankImagePreviewUrl}
//                 alt="Bank passbook full size"
//                 style={{
//                   maxWidth: '100%',
//                   maxHeight: '70vh',
//                   borderRadius: 4,
//                 }}
//               />
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setBankImagePreviewUrl(null)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add Driver Dialog */}
//       <Dialog open={openAddDialog} onClose={handleCloseAddDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>{editMode ? 'Edit Driver' : 'Add Driver'}</DialogTitle>
//         <form onSubmit={formik.handleSubmit}>
//           <DialogContent>
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Name"
//                   name="name"
//                   placeholder="Enter Full Name"
//                   value={formik.values.name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.name && Boolean(formik.errors.name)}
//                   helperText={formik.touched.name && formik.errors.name}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Phone Number"
//                   name="phone"
//                   placeholder="+91 9876543210"
//                   value={formik.values.phone}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.phone && Boolean(formik.errors.phone)}
//                   helperText={formik.touched.phone && formik.errors.phone}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <FormControl
//                   fullWidth
//                   error={formik.touched.gender && Boolean(formik.errors.gender)}
//                 >
//                   <InputLabel>Gender</InputLabel>
//                   <Select
//                     name="gender"
//                     value={formik.values.gender}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     label="Gender"
//                   >
//                     <MenuItem value="Male">Male</MenuItem>
//                     <MenuItem value="Female">Female</MenuItem>
//                   </Select>
//                   {formik.touched.gender && formik.errors.gender && (
//                     <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                       {formik.errors.gender}
//                     </Typography>
//                   )}
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <FormControl
//                   fullWidth
//                   error={formik.touched.region && Boolean(formik.errors.region)}
//                 >
//                   <InputLabel>Region</InputLabel>
//                   <Select
//                     name="region"
//                     value={formik.values.region}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     label="Region"
//                   >
//                     {regions.map((region) => (
//                       <MenuItem key={region.id} value={region.id}>
//                         {region.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {formik.touched.region && formik.errors.region && (
//                     <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                       {formik.errors.region}
//                     </Typography>
//                   )}
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <FormControl
//                   fullWidth
//                   error={formik.touched.vehicleType && Boolean(formik.errors.vehicleType)}
//                 >
//                   <InputLabel>Vehicle Type</InputLabel>
//                   <Select
//                     name="vehicleType"
//                     value={formik.values.vehicleType}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     label="Vehicle Type"
//                   >
//                     {services.length === 0 ? (
//                       <MenuItem disabled>No services available. Please add services first.</MenuItem>
//                     ) : (
//                       services.map((service) => (
//                         <MenuItem key={service.id} value={service.id}>
//                           {service.service_name}
//                         </MenuItem>
//                       ))
//                     )}
//                   </Select>
//                   {formik.touched.vehicleType && formik.errors.vehicleType && (
//                     <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                       {formik.errors.vehicleType}
//                     </Typography>
//                   )}
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Vehicle Number"
//                   name="vehicleNumber"
//                   placeholder="KA 01 AB 1234"
//                   value={formik.values.vehicleNumber}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)}
//                   helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Vehicle Model"
//                   name="vehicleModel"
//                   placeholder="Honda City"
//                   value={formik.values.vehicleModel}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.vehicleModel && Boolean(formik.errors.vehicleModel)}
//                   helperText={formik.touched.vehicleModel && formik.errors.vehicleModel}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <FormControl
//                   fullWidth
//                   error={formik.touched.status && Boolean(formik.errors.status)}
//                 >
//                   <InputLabel>Status</InputLabel>
//                   <Select
//                     name="status"
//                     value={formik.values.status}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     label="Status"
//                   >
//                     <MenuItem value="active">Active</MenuItem>
//                     <MenuItem value="pending">Pending</MenuItem>
//                     <MenuItem value="blocked">Blocked</MenuItem>
//                   </Select>
//                   {formik.touched.status && formik.errors.status && (
//                     <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                       {formik.errors.status}
//                     </Typography>
//                   )}
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Driver Photo *
//                   </Typography>
//                   <Button
//                     variant="outlined"
//                     component="label"
//                     sx={{
//                       borderColor: '#FFC107',
//                       color: '#000',
//                       '&:hover': {
//                         borderColor: '#FFD54F',
//                         bgcolor: 'rgba(255, 193, 7, 0.1)',
//                       },
//                     }}
//                   >
//                     Choose Photo
//                     <input
//                       type="file"
//                       hidden
//                       accept="image/*"
//                       onChange={handlePhotoChange}
//                     />
//                   </Button>
//                   {driverPhotoPreview && (
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Box
//                         component="img"
//                         src={driverPhotoPreview}
//                         alt="Driver preview"
//                         sx={{
//                           width: 100,
//                           height: 100,
//                           objectFit: 'cover',
//                           borderRadius: 2,
//                           border: '2px solid #FFC107',
//                         }}
//                       />
//                       <Typography variant="body2" color="text.secondary">
//                         {driverPhoto?.name}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Grid>
//             </Grid>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseAddDialog}>Cancel</Button>
//             <Button
//               type="submit"
//               variant="contained"
//               disabled={formik.isSubmitting}
//               sx={{
//                 bgcolor: '#FFC107',
//                 color: '#000',
//                 '&:hover': {
//                   bgcolor: '#FFD54F',
//                 },
//               }}
//             >
//               {editMode ? 'Update Driver' : 'Add Driver'}
//             </Button>
//           </DialogActions>
//         </form>
//       </Dialog>

//       {/* Assign Recharge Dialog */}
//       <Dialog open={openRechargeDialog} onClose={handleCloseRechargeDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <AccountBalanceWallet sx={{ color: '#FF9800' }} />
//             Assign Recharge Plan
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {rechargeDriver && (
//             <Box sx={{ pt: 2 }}>
//               {/* Driver Info */}
//               <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                 <Typography variant="subtitle1" fontWeight={600}>
//                   {rechargeDriver.name}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {rechargeDriver.phone} • {rechargeDriver.vehicleType}
//                 </Typography>
//               </Box>

//               {/* Current Recharge Status */}
//               {driverRechargeStatus && (
//                 <Alert
//                   severity={driverRechargeStatus.hasActiveRecharge ? 'success' : 'warning'}
//                   sx={{ mb: 3 }}
//                 >
//                   {driverRechargeStatus.hasActiveRecharge ? (
//                     <>
//                       Active recharge: {driverRechargeStatus.remainingDays} days remaining
//                       <br />
//                       <Typography variant="caption">
//                         Expires: {new Date(driverRechargeStatus.subscriptionExpiry).toLocaleDateString()}
//                       </Typography>
//                     </>
//                   ) : (
//                     'No active recharge plan'
//                   )}
//                 </Alert>
//               )}

//               {/* Select Plan */}
//               <FormControl fullWidth sx={{ mb: 3 }}>
//                 <InputLabel>Select Recharge Plan</InputLabel>
//                 <Select
//                   value={selectedPlanId}
//                   onChange={(e) => {
//                     setSelectedPlanId(e.target.value);
//                     setCustomDays(''); // Clear custom days when plan is selected
//                   }}
//                   label="Select Recharge Plan"
//                 >
//                   <MenuItem value="">
//                     <em>-- Select a plan or enter custom days below --</em>
//                   </MenuItem>
//                   {rechargePlans.map((plan) => (
//                     <MenuItem key={plan.id} value={plan.id}>
//                       {plan.name || `${plan.days} Days`} - ₹{plan.price} ({plan.days} days)
//                       {plan.service_name && ` • ${plan.service_name}`}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {/* OR Divider */}
//               <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                 <Box sx={{ flex: 1, height: 1, bgcolor: '#ddd' }} />
//                 <Typography sx={{ px: 2, color: 'text.secondary' }}>OR</Typography>
//                 <Box sx={{ flex: 1, height: 1, bgcolor: '#ddd' }} />
//               </Box>

//               {/* Custom Days */}
//               <TextField
//                 fullWidth
//                 label="Custom Days (Free Assignment)"
//                 type="number"
//                 value={customDays}
//                 onChange={(e) => {
//                   setCustomDays(e.target.value);
//                   setSelectedPlanId(''); // Clear plan when custom days is entered
//                 }}
//                 placeholder="Enter number of days"
//                 inputProps={{ min: 1 }}
//                 sx={{ mb: 3 }}
//                 helperText="Enter custom days for free admin assignment"
//               />

//               {/* Notes */}
//               <TextField
//                 fullWidth
//                 label="Notes (Optional)"
//                 value={rechargeNotes}
//                 onChange={(e) => setRechargeNotes(e.target.value)}
//                 placeholder="e.g., Promotional offer, Compensation, etc."
//                 multiline
//                 rows={2}
//               />
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseRechargeDialog}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleAssignRecharge}
//             disabled={rechargeLoading || (!selectedPlanId && !customDays)}
//             sx={{
//               bgcolor: '#FF9800',
//               color: '#fff',
//               '&:hover': {
//                 bgcolor: '#F57C00',
//               },
//             }}
//           >
//             {rechargeLoading ? 'Assigning...' : 'Assign Recharge'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default DriversPage;

import React, { useState, useEffect, useCallback, useRef  } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  Avatar,
  CircularProgress,
  Paper,
  Stack,
  Tooltip,
  Divider,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Snackbar,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Search,
  Add,
  Visibility,
  Edit,
  Block,
  Delete,
  CheckCircle,
  Cancel,
  AccountBalanceWallet,
  CloudUpload,
  Close,
  PhotoCamera,
  People,
  CheckCircle as ActiveIcon,
  Block as BlockedIcon,
  PersonOff as InactiveIcon,
  Pending as PendingIcon,
  Verified,
  AccountBalance,
  Save,
  Clear,
  Male,
  Female,
  Refresh,
} from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import apiService from '../services/apiService';
import config from '../config/config';

// Add this import at the top
import { useAuth } from '../context/AuthContext';

const ALL_ROLES = ['super_admin', 'taxi_attachment'];  // Both roles can access
const ADMIN_ONLY = ['super_admin'];                    // Only super_admin can access
const TAXI_ATTACHMENT_ONLY = ['taxi_attachment'];      // Only taxi_attachment can access

// Default photo paths based on gender
const DEFAULT_PHOTO_MALE = '/uploads/profile_photos/male.jpg';
const DEFAULT_PHOTO_FEMALE = '/uploads/profile_photos/female.jpg';

const DriversPage = () => {

  // Get user from auth context
  const { user: authUser, loading: authLoading } = useAuth();
  
  // Determine user role - define it at the component level
  const userRole = authUser?.role || authUser?.user_role || null;
  
  // Check if user has admin access
  const isAdmin = userRole === 'super_admin' || userRole === 'admin';
  const isTaxiAttachment = userRole === 'taxi_attachment';

  // Debug logs (remove in production)
  console.log('Auth User:', authUser);
  console.log('User Role:', userRole);
  console.log('Is Admin:', isAdmin);
  console.log('Is Taxi Attachment:', isTaxiAttachment);

  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [regions, setRegions] = useState([]);
  const [services, setServices] = useState([]);
  const [driverPhoto, setDriverPhoto] = useState(null);
  const [driverPhotoPreview, setDriverPhotoPreview] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editingDriver, setEditingDriver] = useState(null);
  const [bankImagePreviewUrl, setBankImagePreviewUrl] = useState(null);
  const [photoChanged, setPhotoChanged] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // Bank document state
  const [bankDocument, setBankDocument] = useState(null);
  const [bankDocumentPreview, setBankDocumentPreview] = useState(null);
  const [bankDocumentChanged, setBankDocumentChanged] = useState(false);

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [activeDrivers, setActiveDrivers] = useState(0);
  const [inactiveDrivers, setInactiveDrivers] = useState(0);
  const [blockedDrivers, setBlockedDrivers] = useState(0);
  const [verificationPendingStatusDrivers, setVerificationPendingStatusDrivers] = useState(0);
  const [verifiedDrivers, setVerifiedDrivers] = useState(0);

  // Recharge dialog state
  const [openRechargeDialog, setOpenRechargeDialog] = useState(false);
  const [rechargeDriver, setRechargeDriver] = useState(null);
  const [rechargePlans, setRechargePlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [customDays, setCustomDays] = useState('');
  const [rechargeNotes, setRechargeNotes] = useState('');
  const [rechargeLoading, setRechargeLoading] = useState(false);
  const [driverRechargeStatus, setDriverRechargeStatus] = useState(null);

  // Debounce timer ref
  const debounceTimerRef = useRef(null);

  // Helper function to get default photo path based on gender
  const getDefaultPhotoPath = (gender) => {
    if (gender === 'Male') return DEFAULT_PHOTO_MALE;
    if (gender === 'Female') return DEFAULT_PHOTO_FEMALE;
    return null;
  };

  // Helper function to get default photo URL for preview
  const getDefaultPhotoUrl = (gender) => {
    const path = getDefaultPhotoPath(gender);
    if (!path) return null;
    const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
    return `${baseUrl}${path}`;
  };

  // Function to get default photo file based on gender
  const getDefaultPhotoFile = (gender) => {
    if (gender === 'Male') {
      return '/uploads/profile_photos/male.jpg';
    } else if (gender === 'Female') {
      return '/uploads/profile_photos/female.jpg';
    }
    return null;
  };

  // Show snackbar notification
  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const fetchDrivers = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      // Build params with pagination
      const params = {
        page: paginationModel.page + 1, // API expects 1-based page
        limit: paginationModel.pageSize,
      };
      
      if (statusFilter !== 'all') {
        params.status = statusFilter;
      }
      
      if (searchQuery && searchQuery.trim()) {
        params.search = searchQuery.trim();
      }

      console.log('Fetching drivers with params:', params);
      const response = await apiService.getDrivers(params);
      console.log('Drivers response:', response);

      if (response && response.success) {
        // Handle different response structures
        let driversData = [];
        let pagination = {};
        
        if (response.data) {
          if (Array.isArray(response.data)) {
            driversData = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            driversData = response.data.data;
            pagination = response.data.pagination || response.pagination || {};
          } else {
            driversData = response.data;
          }
        } else if (Array.isArray(response)) {
          driversData = response;
        }
        
        // Ensure driversData is an array
        if (!Array.isArray(driversData)) {
          driversData = [];
        }
        
        const total = pagination.total || response.pagination?.total || driversData.length || 0;
        
        console.log('Drivers data:', driversData);
        setDrivers(driversData);
        setRowCount(total);
        setTotalDrivers(total);
        setError('');
        
        // Calculate stats from the data or from response
        if (response.stats) {
          setActiveDrivers(response.stats.active || 0);
          setInactiveDrivers(response.stats.inactive || 0);
          setBlockedDrivers(response.stats.blocked || 0);
          setVerificationPendingStatusDrivers(response.stats.verificationStatus || 0);
          setVerifiedDrivers(response.stats.verified || 0);
        } else {
          // Fallback: calculate from all drivers if stats not provided
          calculateStats(driversData);
        }
      } else {
        // Handle unsuccessful response
        const errorMessage = response?.message || 'Failed to fetch drivers';
        console.warn('Drivers fetch unsuccessful:', errorMessage);
        setDrivers([]);
        setRowCount(0);
        setTotalDrivers(0);
        setActiveDrivers(0);
        setInactiveDrivers(0);
        setBlockedDrivers(0);
        setVerificationPendingStatusDrivers(0);
        setVerifiedDrivers(0);
        
        // Don't show error for "no drivers" case
        if (!errorMessage.toLowerCase().includes('no drivers')) {
          setError(errorMessage);
        } else {
          setError('');
        }
      }
    } catch (err) {
      console.error('Drivers fetch error:', err);
      setDrivers([]);
      setRowCount(0);
      setTotalDrivers(0);
      setActiveDrivers(0);
      setInactiveDrivers(0);
      setBlockedDrivers(0);
      setVerificationPendingStatusDrivers(0);
      setVerifiedDrivers(0);

      // Improved error handling
      if (err.code === 'ECONNREFUSED' || err.code === 'ERR_NETWORK' || err.message?.includes('Network Error')) {
        setError(`Unable to connect to backend server. Please ensure the backend is running on ${config.SOCKET_URL}`);
      } else if (err.response?.status === 401) {
        setError('Session expired. Please login again.');
        // Optionally redirect to login
      } else if (err.response?.status === 403) {
        setError('You do not have permission to view drivers.');
      } else if (err.response?.status === 404) {
        // API endpoint not found - might be a configuration issue
        setError(`API endpoint not found. Please check the API configuration.`);
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.');
      } else if (err.response) {
        const errorMessage = err.response.data?.message || err.message || 'An error occurred';
        if (errorMessage && !errorMessage.toLowerCase().includes('no drivers')) {
          setError(errorMessage);
        } else {
          setError('');
        }
      } else if (err.message && !err.message.toLowerCase().includes('no drivers')) {
        setError(err.message);
      } else {
        setError('');
      }
    } finally {
      setLoading(false);
    }
  }, [statusFilter, paginationModel.page, paginationModel.pageSize, searchQuery]);

  // Helper function to calculate stats from drivers array
  const calculateStats = (driversList) => {
    if (!driversList || driversList.length === 0) {
      setActiveDrivers(0);
      setInactiveDrivers(0);
      setBlockedDrivers(0);
      setVerificationPendingStatusDrivers(0);
      setVerifiedDrivers(0);
      return;
    }
    
    const active = driversList.filter(d => d.status === 'active').length;
    const blocked = driversList.filter(d => d.status === 'blocked').length;
    const inactive = driversList.filter(d => d.status === 'inactive' || d.status === 'pending').length;
    const verificationPending = driversList.filter(d => d.verificationStatus === 'pending' || d.verification_status === 'pending').length;
    const verified = driversList.filter(d => d.verificationStatus === 'verified' || d.verification_status === 'verified').length;

    setActiveDrivers(active);
    setBlockedDrivers(blocked);
    setInactiveDrivers(inactive);
    setVerificationPendingStatusDrivers(verificationPending);
    setVerifiedDrivers(verified);
  };

  const fetchRegions = async () => {
    try {
      const response = await apiService.getRegions();
      if (response && response.success) {
        setRegions(response.data?.data || response.data || []);
      }
    } catch (err) {
      console.error('Regions error:', err);
      // Don't show error for regions - they're not critical
    }
  };

  const fetchServices = async () => {
    try {
      const response = await apiService.getServices();
      console.log('Services Response:', response);
      if (response && response.success) {
        const servicesData = response.data?.data || response.data || [];
        console.log('Services Data:', servicesData);
        setServices(servicesData);
      }
    } catch (err) {
      console.error('Services error:', err);
      // Don't show error for services - they're not critical
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchDrivers();
    fetchRegions();
    fetchServices();
  }, []); // Run only once on mount

  // Handle pagination change
  useEffect(() => {
    fetchDrivers();
  }, [paginationModel.page, paginationModel.pageSize, statusFilter]);

  // Debounced search
  useEffect(() => {
    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    // Set new timer
    debounceTimerRef.current = setTimeout(() => {
      // Reset to first page when searching
      if (searchQuery.trim() !== '') {
        setPaginationModel(prev => ({
          ...prev,
          page: 0,
        }));
      }
      fetchDrivers();
    }, 500);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [searchQuery]); // Only run when searchQuery changes

  const handleViewDriver = async (driver) => {
    setSelectedDriver(driver);
    setOpenDialog(true);
  };

  const handleBlockDriver = async (driverId) => {
    if (!window.confirm('Are you sure you want to block this driver?')) {
      return;
    }

    try {
      const response = await apiService.blockDriver(driverId, 'Blocked by admin');

      if (response && response.success) {
        showSnackbar('Driver blocked successfully', 'success');
        fetchDrivers();
      } else {
        showSnackbar(response?.message || 'Failed to block driver', 'error');
      }
    } catch (err) {
      console.error('Block driver error:', err);
      showSnackbar('Failed to block driver', 'error');
    }
  };

  const handleDeleteDriver = async (driverId) => {
    if (!window.confirm('Are you sure you want to delete this driver? This action cannot be undone.')) {
      return;
    }

    try {
      const response = await apiService.deleteDriver(driverId);

      if (response && response.success) {
        showSnackbar('Driver deleted successfully', 'success');
        fetchDrivers();
      } else {
        showSnackbar(response?.message || 'Failed to delete driver', 'error');
      }
    } catch (err) {
      console.error('Delete driver error:', err);
      showSnackbar('Failed to delete driver', 'error');
    }
  };

  // Recharge handlers
  const handleOpenRechargeDialog = async (driver) => {
    setRechargeDriver(driver);
    setSelectedPlanId('');
    setCustomDays('');
    setRechargeNotes('');
    setOpenRechargeDialog(true);

    try {
      const [plansResponse, statusResponse] = await Promise.all([
        apiService.getAdminRechargePlans(driver.id),
        apiService.getDriverRechargeStatus(driver.id)
      ]);

      if (plansResponse && plansResponse.success) {
        setRechargePlans(plansResponse.data || []);
      }

      if (statusResponse && statusResponse.success) {
        setDriverRechargeStatus(statusResponse.data);
      }
    } catch (err) {
      console.error('Error fetching recharge data:', err);
      // Don't show error - just log it
    }
  };

  const handleCloseRechargeDialog = () => {
    setOpenRechargeDialog(false);
    setRechargeDriver(null);
    setRechargePlans([]);
    setSelectedPlanId('');
    setCustomDays('');
    setRechargeNotes('');
    setDriverRechargeStatus(null);
  };

  const handleAssignRecharge = async () => {
    if (!selectedPlanId && !customDays) {
      showSnackbar('Please select a plan or enter custom days', 'warning');
      return;
    }

    if (customDays && (isNaN(customDays) || parseInt(customDays) < 1)) {
      showSnackbar('Please enter a valid number of days', 'warning');
      return;
    }

    setRechargeLoading(true);

    try {
      const data = {
        notes: rechargeNotes || 'Assigned by admin'
      };

      if (selectedPlanId) {
        data.planId = selectedPlanId;
      } else {
        data.days = parseInt(customDays);
        data.amount = 0;
      }

      const response = await apiService.assignDriverRecharge(rechargeDriver.id, data);

      if (response && response.success) {
        showSnackbar(`Recharge assigned successfully! ${response.data?.rechargeDays || customDays} days added.`, 'success');
        handleCloseRechargeDialog();
        fetchDrivers();
      } else {
        showSnackbar(response?.message || 'Failed to assign recharge', 'error');
      }
    } catch (err) {
      console.error('Assign recharge error:', err);
      showSnackbar('Failed to assign recharge', 'error');
    } finally {
      setRechargeLoading(false);
    }
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showSnackbar('Please select an image file', 'warning');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showSnackbar('File size should not exceed 5MB', 'warning');
        event.target.value = '';
        return;
      }
      setDriverPhoto(file);
      setPhotoChanged(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setDriverPhotoPreview(reader.result);
      };
      reader.onerror = () => {
        showSnackbar('Failed to read file', 'error');
        setDriverPhoto(null);
        event.target.value = '';
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemovePhoto = () => {
    setDriverPhoto(null);
    setPhotoChanged(true);
    const fileInput = document.getElementById('driver-photo-input');
    if (fileInput) {
      fileInput.value = '';
    }
    // When photo is removed, show default gender photo
    const gender = formik.values.gender || 'Male';
    const defaultUrl = getDefaultPhotoUrl(gender);
    setDriverPhotoPreview(defaultUrl || null);
  };

  // Bank document handlers
  const handleBankDocumentChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showSnackbar('Please select an image file', 'warning');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showSnackbar('File size should not exceed 5MB', 'warning');
        event.target.value = '';
        return;
      }
      setBankDocument(file);
      setBankDocumentChanged(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setBankDocumentPreview(reader.result);
      };
      reader.onerror = () => {
        showSnackbar('Failed to read file', 'error');
        setBankDocument(null);
        event.target.value = '';
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveBankDocument = () => {
    setBankDocument(null);
    setBankDocumentPreview(null);
    setBankDocumentChanged(true);
    const fileInput = document.getElementById('bank-document-input');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setIsSubmitting(true);
    try {
      let response;

      if (editMode) {
        const driverId = editingDriver.id;
        
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('phone', values.phone);
        // formData.append('phone', `+91${values.phone}`);
        formData.append('gender', values.gender);
        formData.append('region', values.region);
        formData.append('vehicleType', values.vehicleType);
        formData.append('vehicleNumber', values.vehicleNumber);
        formData.append('vehicleModel', values.vehicleModel);
        formData.append('status', values.status);
        
        // Bank details
        if (values.bankAccountNumber) {
          formData.append('bank_account_number', values.bankAccountNumber);
        } else {
          formData.append('bank_account_number', '');
        }
        if (values.bankIfscCode) {
          formData.append('bank_ifsc_code', values.bankIfscCode);
        } else {
          formData.append('bank_ifsc_code', '');
        }
        
        // Photo handling for edit mode
        if (photoChanged) {
          if (driverPhoto) {
            // User uploaded a custom photo
            formData.append('photo', driverPhoto);
          } else {
            // User wants to use default photo based on gender
            const defaultPhotoPath = getDefaultPhotoFile(values.gender);
            if (defaultPhotoPath) {
              formData.append('photo', defaultPhotoPath);
            }
            formData.append('remove_photo', 'true');
          }
        }
        
        response = await apiService.updateDriver(driverId, formData);
        
        if (response && response.success) {
          // Handle bank document separately if changed
          if (bankDocumentChanged) {
            if (bankDocument) {
              await apiService.uploadBankDocument(driverId, bankDocument);
            } else {
              await apiService.removeBankDocument(driverId);
            }
          }
          
          showSnackbar('Driver updated successfully', 'success');
          setOpenAddDialog(false);
          setEditMode(false);
          setEditingDriver(null);
          resetForm();
          setDriverPhoto(null);
          setDriverPhotoPreview(null);
          setPhotoChanged(false);
          setBankDocument(null);
          setBankDocumentPreview(null);
          setBankDocumentChanged(false);
          fetchDrivers();
        } else {
          const errorMsg = response?.message || response?.error?.message || 'Failed to update driver';
          console.error('Update failed:', errorMsg);
          showSnackbar(errorMsg, 'error');
        }
      } else {
        // Add new driver
        const formData = new FormData();
        formData.append('name', values.name);
        // formData.append('phone', values.phone);
        formData.append('phone', `+91${values.phone}`);
        formData.append('gender', values.gender);
        formData.append('region', values.region);
        formData.append('vehicleType', values.vehicleType);
        formData.append('vehicleNumber', values.vehicleNumber);
        formData.append('vehicleModel', values.vehicleModel);
        formData.append('status', values.status);
        
        if (driverPhoto) {
          formData.append('profile_photo', driverPhoto);
        }
        
        if (values.bankAccountNumber) {
          formData.append('bank_account_number', values.bankAccountNumber);
        }
        if (values.bankIfscCode) {
          formData.append('bank_ifsc_code', values.bankIfscCode);
        }
        
        response = await apiService.addDriver(formData);

        if (response && response.success) {
          // If bank document was provided, upload it after driver creation
          if (bankDocument) {
            try {
              const driverId = response.data?.driverId || response.data?.id;
              if (driverId) {
                await apiService.uploadBankDocument(driverId, bankDocument);
              }
            } catch (err) {
              console.warn('Bank document upload failed after driver creation:', err);
            }
          }
          
          showSnackbar('Driver added successfully', 'success');
          setOpenAddDialog(false);
          resetForm();
          setDriverPhoto(null);
          setDriverPhotoPreview(null);
          setPhotoChanged(false);
          setBankDocument(null);
          setBankDocumentPreview(null);
          setBankDocumentChanged(false);
          fetchDrivers();
        } else {
          const errorMsg = response?.message || response?.error?.message || 'Failed to add driver';
          console.error('Failed to add driver:', errorMsg, response);
          showSnackbar(errorMsg, 'error');
        }
      }
    } catch (err) {
      console.error('Driver operation error:', err);
      console.error('Error details:', err.response || err);
      
      let errorMsg = 'Operation failed';
      if (err.response?.data?.message) {
        errorMsg = err.response.data.message;
      } else if (err.response?.data?.error) {
        errorMsg = err.response.data.error;
      } else if (err.message) {
        errorMsg = err.message;
      }
      
      showSnackbar('Error: ' + errorMsg, 'error');
    } finally {
      setSubmitting(false);
      setIsSubmitting(false);
    }
  };

  // Get existing bank details from editing driver
  const getExistingBankDetails = () => {
    if (editMode && editingDriver) {
      return {
        bankAccountNumber: editingDriver.bank_account_number || editingDriver.bankAccountNumber || '',
        bankIfscCode: editingDriver.bank_ifsc_code || editingDriver.bankIfscCode || '',
        bankAccountImage: editingDriver.bank_account_image || editingDriver.bankAccountImage || null,
      };
    }
    return {
      bankAccountNumber: '',
      bankIfscCode: '',
      bankAccountImage: null,
    };
  };

  // Handle gender change to update photo preview
  const handleGenderChange = (event) => {
    const gender = event.target.value;
    formik.setFieldValue('gender', gender);
    
    if (!driverPhoto && !(editMode && editingDriver?.photo)) {
      const defaultUrl = getDefaultPhotoUrl(gender);
      setDriverPhotoPreview(defaultUrl || null);
    }
    
    if (editMode && editingDriver) {
      const currentPhoto = editingDriver.photo || editingDriver.profile_photo;
      if (currentPhoto) {
        const isDefaultPhoto = String(currentPhoto).includes('profile_photos');
        if (isDefaultPhoto || !driverPhoto) {
          setPhotoChanged(true);
          setDriverPhoto(null);
          const defaultUrl = getDefaultPhotoUrl(gender);
          setDriverPhotoPreview(defaultUrl || null);
        }
      } else {
        const defaultUrl = getDefaultPhotoUrl(gender);
        setDriverPhotoPreview(defaultUrl || null);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      name: editMode && editingDriver ? editingDriver.name : '',
      phone: editMode && editingDriver ? editingDriver.phone : '',
      gender: editMode && editingDriver ? editingDriver.gender : 'Male',
      region: editMode && editingDriver ? editingDriver.region_id : '',
      vehicleType: editMode && editingDriver ? editingDriver.vehicleTypeId : '',
      vehicleNumber: editMode && editingDriver ? editingDriver.vehicleNumber : '',
      vehicleModel: editMode && editingDriver ? editingDriver.vehicleModel : '',
      status: editMode && editingDriver ? editingDriver.status : 'pending',
      bankAccountNumber: getExistingBankDetails().bankAccountNumber,
      bankIfscCode: getExistingBankDetails().bankIfscCode,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required').min(3, 'Name must be at least 3 characters'),
      phone: Yup.string()
        .required('Phone number is required')
        .matches(/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/im, 'Invalid phone number'),
      gender: Yup.string().required('Gender is required'),
      region: Yup.string().required('Region is required'),
      vehicleType: Yup.string().required('Vehicle Type is required'),
      vehicleNumber: Yup.string().required('Vehicle Number is required'),
      vehicleModel: Yup.string().required('Vehicle Model is required'),
      status: Yup.string().required('Status is required'),
      bankAccountNumber: Yup.string().optional(),
      bankIfscCode: Yup.string().optional().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format'),
    }),
    onSubmit: handleSubmit,
  });

  const handleAddDriver = () => {
    setEditMode(false);
    setEditingDriver(null);
    setPhotoChanged(false);
    setBankDocumentChanged(false);
    formik.resetForm();
    formik.setFieldValue('gender', 'Male');
    setDriverPhoto(null);
    setDriverPhotoPreview(getDefaultPhotoUrl('Male'));
    setBankDocument(null);
    setBankDocumentPreview(null);
    setOpenAddDialog(true);
  };

  const handleEditDriver = (driver) => {
    setEditMode(true);
    setEditingDriver(driver);
    setPhotoChanged(false);
    setBankDocumentChanged(false);
    setDriverPhoto(null);
    
    formik.setValues({
      name: driver.name || '',
      phone: driver.phone || '',
      gender: driver.gender || 'Male',
      region: driver.region_id || '',
      vehicleType: driver.vehicleTypeId || '',
      vehicleNumber: driver.vehicleNumber || '',
      vehicleModel: driver.vehicleModel || '',
      status: driver.status || 'pending',
      bankAccountNumber: driver.bank_account_number || driver.bankAccountNumber || '',
      bankIfscCode: driver.bank_ifsc_code || driver.bankIfscCode || '',
    });
    
    const hasPhoto = driver.photo || driver.profile_photo;
    
    if (hasPhoto) {
      const photoPath = String(hasPhoto);
      const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
      const cleanPath = photoPath.trim().replace(/^\/+/, '');
      setDriverPhotoPreview(`${baseUrl}/${cleanPath}`);
    } else {
      const defaultUrl = getDefaultPhotoUrl(driver.gender || 'Male');
      setDriverPhotoPreview(defaultUrl || null);
    }
    
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    setEditMode(false);
    setEditingDriver(null);
    setPhotoChanged(false);
    setBankDocumentChanged(false);
    formik.resetForm();
    setDriverPhoto(null);
    setDriverPhotoPreview(null);
    setBankDocument(null);
    setBankDocumentPreview(null);
    setIsSubmitting(false);
  };

  // Retry fetch
  const handleRetry = () => {
    fetchDrivers();
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      active: { label: 'Active', color: 'success' },
      pending: { label: 'Pending', color: 'warning' },
      blocked: { label: 'Blocked', color: 'error' },
      inactive: { label: 'Inactive', color: 'default' },
    };

    const config = statusConfig[status] || statusConfig.inactive;
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const getVerificationChip = (status) => {
    const statusConfig = {
      verified: { label: 'Verified', color: 'success', icon: <CheckCircle /> },
      pending: { label: 'Pending', color: 'warning' },
      rejected: { label: 'Rejected', color: 'error', icon: <Cancel /> },
    };

    const config = statusConfig[status] || statusConfig.pending;
    return <Chip label={config.label} color={config.color} size="small" icon={config.icon} />;
  };

  const columns = [
    {
      field: 'profile_photo',
      headerName: 'Driver Photo',
      width: 100,
      renderCell: (params) => {
        const photoUrl = params.row.profile_photo || params.row.photo;
        const gender = params.row.gender;
        const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
        
        const getDefaultPhoto = (gender) => {
          if (gender === 'Male') return '/uploads/profile_photos/male.jpg';
          if (gender === 'Female') return '/uploads/profile_photos/female.jpg';
          return null;
        };
        
        if (photoUrl) {
          const cleanPath = String(photoUrl).trim().replace(/^\/+/, '');
          const fullUrl = `${baseUrl}/${cleanPath}`;
          
          return (
            <img 
              src={fullUrl} 
              alt={params.row.name || 'Driver'}
              style={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #FFC107',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                const parent = e.target.parentNode;
                if (parent) {
                  const defaultPath = getDefaultPhoto(gender);
                  if (defaultPath) {
                    const defaultUrl = `${baseUrl}${defaultPath}`;
                    const img = document.createElement('img');
                    img.src = defaultUrl;
                    img.alt = params.row.name || 'Driver';
                    img.style.cssText = 'width: 50px; height: 50px; border-radius: 50%; object-fit: cover; border: 2px solid #FFC107;';
                    img.onerror = () => {
                      img.style.display = 'none';
                      const fallback = document.createElement('div');
                      fallback.style.cssText = 'width: 50px; height: 50px; border-radius: 50%; background: #9E9E9E; display: flex; align-items: center; justify-content: center; font-size: 20px; color: #fff;';
                      fallback.textContent = params.row.name?.charAt(0).toUpperCase() || 'D';
                      parent.appendChild(fallback);
                    };
                    parent.appendChild(img);
                  } else {
                    const fallback = document.createElement('div');
                    fallback.style.cssText = 'width: 50px; height: 50px; border-radius: 50%; background: #9E9E9E; display: flex; align-items: center; justify-content: center; font-size: 20px; color: #fff;';
                    fallback.textContent = params.row.name?.charAt(0).toUpperCase() || 'D';
                    parent.appendChild(fallback);
                  }
                }
              }}
            />
          );
        }
        
        const defaultPath = getDefaultPhoto(gender);
        if (defaultPath) {
          const fullUrl = `${baseUrl}${defaultPath}`;
          return (
            <img 
              src={fullUrl} 
              alt={params.row.name || 'Driver'}
              style={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #FFC107',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                const parent = e.target.parentNode;
                if (parent) {
                  const fallback = document.createElement('div');
                  fallback.style.cssText = 'width: 50px; height: 50px; border-radius: 50%; background: #9E9E9E; display: flex; align-items: center; justify-content: center; font-size: 20px; color: #fff;';
                  fallback.textContent = params.row.name?.charAt(0).toUpperCase() || 'D';
                  parent.appendChild(fallback);
                }
              }}
            />
          );
        }
        
        return (
          <Box sx={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            background: '#9E9E9E',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
            color: '#fff',
          }}>
            {params.row.name?.charAt(0).toUpperCase() || 'D'}
          </Box>
        );
      },
    },
    {
      field: 'name',
      headerName: 'Driver Name',
      width: 180,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            {params.row.name || '-'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.phone}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'user_name',
      headerName: 'Added By',
      width: 150,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.user_name}</Typography>
        </Box>
      ),
    },
    {
      field: 'vehicleType',
      headerName: 'Vehicle',
      width: 150,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.vehicleType}</Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.vehicleNumber}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'regionName',
      headerName: 'Region Name',
      width: 150,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.regionName}</Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.regionState}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'bankAccount',
      headerName: 'Bank Account',
      width: 160,
      renderCell: (params) => {
        const accountNumber = params.row.bank_account_number || params.row.bankAccountNumber;
        const ifscCode = params.row.bank_ifsc_code || params.row.bankIfscCode;
        const hasBankDetails = accountNumber || ifscCode;
        
        if (!hasBankDetails) {
          return (
            <Chip 
              label="Not Provided" 
              size="small" 
              color="default" 
              variant="outlined"
              sx={{ fontStyle: 'italic' }}
            />
          );
        }
        
        return (
          <Tooltip 
            title={`${ifscCode ? `IFSC: ${ifscCode}` : 'No IFSC'}`} 
            placement="top"
            arrow
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AccountBalance sx={{ fontSize: 16, color: '#1976D2' }} />
              <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 500 }}>
                {accountNumber ? `****${accountNumber.slice(-4)}` : 'No A/C'}
              </Typography>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => getStatusChip(params.row.status),
    },
    {
      field: 'verificationStatus',
      headerName: 'Verification',
      width: 130,
      renderCell: (params) => getVerificationChip(params.row.verificationStatus),
    },
    {
      field: 'rating',
      headerName: 'Rating',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2">
          ⭐ {Number(params.row.rating || 0).toFixed(2)}
        </Typography>
      ),
    },
    {
      field: 'totalRides',
      headerName: 'Total Rides',
      width: 110,
    },
    {
      field: 'isOnline',
      headerName: 'Online',
      width: 100,
      renderCell: (params) => (
        <Chip
          label={params.row.isOnline ? 'Online' : 'Offline'}
          color={params.row.isOnline ? 'success' : 'default'}
          size="small"
        />
      ),
    },
    {
      field: 'walletBalance',
      headerName: 'Wallet',
      width: 110,
      renderCell: (params) => `₹${params.row.walletBalance}`,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 220,
      sortable: false,
      renderCell: (params) => (
        <Box>
          {/* View action - visible to all */}
          <IconButton size="small" onClick={() => handleViewDriver(params.row)}>
            <Visibility fontSize="small" />
          </IconButton>

          {/* Edit action - hide for taxi_attachment role */}
          
          <IconButton
            size="small"
            color="primary"
            onClick={() => handleEditDriver(params.row)}
          >
            <Edit fontSize="small" />
          </IconButton> 
                
          

          {/* Recharge action - hide for taxi_attachment role */}
          {!isTaxiAttachment && (
          <IconButton
            size="small"
            sx={{ color: '#FF9800' }}
            onClick={() => handleOpenRechargeDialog(params.row)}
            title="Assign Recharge"
          >
            <AccountBalanceWallet fontSize="small" />
          </IconButton>
          )}

          {/* Block action - hide for taxi_attachment role */}
          {!isTaxiAttachment && (
          <IconButton
            size="small"
            color="error"
            onClick={() => handleBlockDriver(params.row.id)}
          >
            <Block fontSize="small" />
          </IconButton>
          )}

          {/* Delete action - hide for taxi_attachment role */}
          {!isTaxiAttachment && (
          <IconButton
            size="small"
            color="error"
            onClick={() => handleDeleteDriver(params.row.id)}
          >
            <Delete fontSize="small" />
          </IconButton>  
          )}
        </Box>
      ),
    },
  ];

  // Stats Card Component
  const StatsCard = ({ icon: Icon, title, value, color, bgColor }) => (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: bgColor || 'transparent',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 1,
        },
      }}
    >
      <Box
        sx={{
          p: 1.5,
          borderRadius: 2,
          bgcolor: color + '20',
          color: color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon sx={{ fontSize: 28 }} />
      </Box>
      <Box>
        <Typography variant="h5" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </Box>
    </Paper>
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Drivers
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage all driver accounts
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            startIcon={<Refresh />}
            onClick={handleRetry}
            disabled={loading}
            sx={{
              borderColor: '#FFC107',
              color: '#000',
              '&:hover': {
                borderColor: '#FFD54F',
                bgcolor: 'rgba(255, 193, 7, 0.1)',
              },
            }}
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddDriver}
            sx={{
              bgcolor: '#FFC107',
              color: '#000',
              '&:hover': {
                bgcolor: '#FFD54F',
              },
            }}
          >
            Add Driver
          </Button>
        </Box>
      </Box>

      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 3 }}
          action={
            <Button color="inherit" size="small" onClick={handleRetry}>
              Retry
            </Button>
          }
        >
          {error}
        </Alert>
      )}

      {/* Stats Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={People}
            title="Total Drivers"
            value={totalDrivers}
            color="#1976D2"
            bgColor="#E3F2FD"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={ActiveIcon}
            title="Active Drivers"
            value={activeDrivers}
            color="#2E7D32"
            bgColor="#E8F5E9"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={InactiveIcon}
            title="Inactive/Pending"
            value={inactiveDrivers}
            color="#ED6C02"
            bgColor="#FFF3E0"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={BlockedIcon}
            title="Blocked Drivers"
            value={blockedDrivers}
            color="#D32F2F"
            bgColor="#FFEBEE"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={PendingIcon}
            title="Verification Pending"
            value={verificationPendingStatusDrivers}
            color="#FF9800"
            bgColor="#FFF3E0"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StatsCard
            icon={Verified}
            title="Verified Drivers"
            value={verifiedDrivers}
            color="#2E7D32"
            bgColor="#E8F5E9"
          />
        </Grid>
      </Grid>

      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search by name, phone, or vehicle number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setSearchQuery('')}
                      sx={{ color: 'text.secondary' }}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ flexGrow: 1, minWidth: 200 }}
            />
            <FormControl sx={{ minWidth: 150 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  setPaginationModel(prev => ({ ...prev, page: 0 }));
                }}
                label="Status"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="blocked">Blocked</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <DataGrid
            rows={drivers}
            columns={columns}
            rowCount={rowCount}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10, 25, 50, 100]}
            disableRowSelectionOnClick
            autoHeight
            loading={loading}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
            localeText={{
              noRowsLabel: error ? 'Error loading drivers' : 'No drivers found. Click "Add Driver" to create your first driver.',
            }}
          />
        </CardContent>
      </Card>

      {/* View Driver Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Driver Details</DialogTitle>
        <DialogContent>
          {selectedDriver && (
            <Box sx={{ pt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Photo</Typography>
                  {selectedDriver.profile_photo || selectedDriver.photo ? (
                    <img 
                      src={`${config.SOCKET_URL}/${String(selectedDriver.profile_photo || selectedDriver.photo).replace(/^\/+/, '')}`}
                      alt={selectedDriver.name}
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '2px solid #FFC107',
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : (
                    <Box sx={{
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      background: selectedDriver.gender === 'Male' ? '#1976D2' : selectedDriver.gender === 'Female' ? '#E91E63' : '#9E9E9E',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 40,
                      color: '#fff',
                    }}>
                      {selectedDriver.name?.charAt(0).toUpperCase() || 'D'}
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Name</Typography>
                  <Typography variant="body1" fontWeight={600}>{selectedDriver.name}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Phone</Typography>
                  <Typography variant="body1">{selectedDriver.phone}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Email</Typography>
                  <Typography variant="body1">{selectedDriver.email || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Vehicle Type</Typography>
                  <Typography variant="body1">{selectedDriver.vehicleType}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Vehicle Number</Typography>
                  <Typography variant="body1">{selectedDriver.vehicleNumber}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedDriver.status)}</Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Verification</Typography>
                  <Box sx={{ mt: 0.5 }}>{getVerificationChip(selectedDriver.verificationStatus)}</Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Rating</Typography>
                  <Typography variant="body1">⭐ {Number(selectedDriver.rating || 0).toFixed(2)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Total Rides</Typography>
                  <Typography variant="body1">{selectedDriver.totalRides || 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Wallet Balance</Typography>
                  <Typography variant="body1">₹{selectedDriver.walletBalance || 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Subscription Expiry</Typography>
                  <Typography variant="body1">
                    {selectedDriver.subscriptionExpiry || 'No active subscription'}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ mt: 2, mb: 1, pt: 2, borderTop: '1px solid #eee' }}>
                    <Typography variant="subtitle1" fontWeight={700}>
                      Bank Details
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Use these to manually credit the driver if needed.
                    </Typography>
                  </Box>
                </Grid>
                {(selectedDriver.bank_account_number || selectedDriver.bankAccountNumber ||
                  selectedDriver.bank_ifsc_code || selectedDriver.bankIfscCode ||
                  selectedDriver.bank_account_image || selectedDriver.bankAccountImage) ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="text.secondary">Account Number</Typography>
                      <Typography variant="body1" fontWeight={600}
                        sx={{ fontFamily: 'monospace', letterSpacing: 0.5 }}>
                        {selectedDriver.bank_account_number ||
                          selectedDriver.bankAccountNumber ||
                          'Not provided'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="text.secondary">IFSC Code</Typography>
                      <Typography variant="body1" fontWeight={600}
                        sx={{ fontFamily: 'monospace', letterSpacing: 0.5 }}>
                        {selectedDriver.bank_ifsc_code ||
                          selectedDriver.bankIfscCode ||
                          'Not provided'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        Passbook / Cheque Image
                      </Typography>
                      {(() => {
                        const imgPath = selectedDriver.bank_account_image || selectedDriver.bankAccountImage;
                        if (!imgPath) {
                          return (
                            <Typography variant="body2" color="text.secondary">
                              No image uploaded
                            </Typography>
                          );
                        }
                        const cleanPath = String(imgPath).trim().replace(/^\/+/, '');
                        const baseUrl = String(config.SOCKET_URL).replace(/\/+$/, '');
                        const fullUrl = `${baseUrl}/${cleanPath}`;
                        return (
                          <Box
                            onClick={() => setBankImagePreviewUrl(fullUrl)}
                            sx={{ display: 'inline-block', cursor: 'pointer' }}
                          >
                            <img
                              src={fullUrl}
                              alt="Bank passbook"
                              style={{
                                maxWidth: 300,
                                maxHeight: 200,
                                display: 'block',
                                borderRadius: 4,
                                border: '1px solid #e0e0e0',
                              }}
                            />
                            <Typography variant="caption" display="block"
                              sx={{ mt: 0.5, color: 'primary.main' }}>
                              Click to view full-size
                            </Typography>
                          </Box>
                        );
                      })()}
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary"
                      sx={{ fontStyle: 'italic' }}>
                      Driver has not provided bank details yet (this is optional).
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Bank Passbook Image Preview Dialog */}
      <Dialog
        open={Boolean(bankImagePreviewUrl)}
        onClose={() => setBankImagePreviewUrl(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Bank Passbook / Cheque
          <IconButton size="small" onClick={() => setBankImagePreviewUrl(null)}>
            <Cancel />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {bankImagePreviewUrl && (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
              <img
                src={bankImagePreviewUrl}
                alt="Bank passbook full size"
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  borderRadius: 4,
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBankImagePreviewUrl(null)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Driver Dialog with Radio Buttons for Gender */}
      <Dialog open={openAddDialog} onClose={handleCloseAddDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{editMode ? 'Edit Driver' : 'Add Driver'}</DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <Grid container spacing={3}>
              {/* Photo upload section */}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Driver Photo (Optional - defaults to gender photo)
                  </Typography>
                  
                  {/* Photo Preview */}
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Avatar
                      src={
                        driverPhotoPreview || 
                        (editMode && editingDriver?.photo && !driverPhotoPreview ? 
                          `${config.SOCKET_URL}/${String(editingDriver.photo).replace(/^\/+/, '')}` : 
                          undefined)
                      }
                      sx={{ 
                        width: 120, 
                        height: 120,
                        border: '3px dashed #ccc',
                        bgcolor: '#f5f5f5',
                      }}
                      imgProps={{
                        onError: (e) => {
                          e.target.style.display = 'none';
                        }
                      }}
                    >
                      {!driverPhotoPreview && !(editMode && editingDriver?.photo) && (
                        formik.values.gender === 'Male' ? (
                          <Box sx={{ textAlign: 'center' }}>
                            <Male sx={{ fontSize: 60, color: '#1976D2' }} />
                            <Typography variant="caption" display="block" color="text.secondary">
                              Male
                            </Typography>
                          </Box>
                        ) : formik.values.gender === 'Female' ? (
                          <Box sx={{ textAlign: 'center' }}>
                            <Female sx={{ fontSize: 60, color: '#E91E63' }} />
                            <Typography variant="caption" display="block" color="text.secondary">
                              Female
                            </Typography>
                          </Box>
                        ) : (
                          <PhotoCamera sx={{ fontSize: 40, color: '#999' }} />
                        )
                      )}
                      {!driverPhotoPreview && editMode && editingDriver?.photo && 
                        editingDriver.name?.charAt(0).toUpperCase()
                      }
                    </Avatar>
                    
                    {/* Remove photo button */}
                    {(driverPhotoPreview || (editMode && editingDriver?.photo)) && (
                      <IconButton
                        size="small"
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          bgcolor: 'error.main',
                          color: 'white',
                          '&:hover': { bgcolor: 'error.dark' },
                        }}
                        onClick={handleRemovePhoto}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    )}
                  </Box>

                  {/* Upload Button */}
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<CloudUpload />}
                    sx={{
                      borderColor: '#FFC107',
                      color: '#000',
                      '&:hover': {
                        borderColor: '#FFD54F',
                        bgcolor: 'rgba(255, 193, 7, 0.1)',
                      },
                    }}
                  >
                    {driverPhotoPreview ? 'Change Photo' : (editMode && editingDriver?.photo ? 'Change Photo' : 'Upload Photo')}
                    <input
                      id="driver-photo-input"
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handlePhotoChange}
                    />
                  </Button>
                  
                  {/* Remove photo button (if photo exists) */}
                  {(driverPhotoPreview || (editMode && editingDriver?.photo)) && (
                    <Button
                      size="small"
                      color="error"
                      onClick={handleRemovePhoto}
                    >
                      Remove Photo
                    </Button>
                  )}
                  
                  {/* Show default photo info */}
                  {!driverPhotoPreview && !(editMode && editingDriver?.photo) && formik.values.gender && (
                    <Typography variant="caption" color="text.secondary">
                      Default {formik.values.gender.toLowerCase()} photo will be used: 
                      {formik.values.gender === 'Male' ? ' male.jpg' : ' female.jpg'}
                    </Typography>
                  )}
                  
                  {driverPhoto && (
                    <Typography variant="caption" color="text.secondary">
                      {driverPhoto.name} ({(driverPhoto.size / 1024).toFixed(1)} KB)
                    </Typography>
                  )}
                  
                  {editMode && editingDriver?.photo && !driverPhotoPreview && (
                    <Typography variant="caption" color="text.secondary">
                      Current photo will be kept unless you change it
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  placeholder="Enter Full Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phone"
                  placeholder="+91 9876543210"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  helperText={formik.touched.phone && formik.errors.phone}
                />
              </Grid>

              {/* Gender Radio Buttons */}
              <Grid item xs={12}>
                <FormControl 
                  fullWidth
                  error={formik.touched.gender && Boolean(formik.errors.gender)}
                >
                  <FormLabel id="gender-radio-buttons-group-label">
                    Gender <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="gender-radio-buttons-group-label"
                    name="gender"
                    value={formik.values.gender}
                    onChange={handleGenderChange}
                    onBlur={formik.handleBlur}
                  >
                    <FormControlLabel 
                      value="Male" 
                      control={<Radio />} 
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Male sx={{ color: '#1976D2' }} />
                          Male
                        </Box>
                      }
                    />
                    <FormControlLabel 
                      value="Female" 
                      control={<Radio />} 
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Female sx={{ color: '#E91E63' }} />
                          Female
                        </Box>
                      }
                    />
                  </RadioGroup>
                  {formik.touched.gender && formik.errors.gender && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                      {formik.errors.gender}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={formik.touched.region && Boolean(formik.errors.region)}
                >
                  <InputLabel>Region</InputLabel>
                  <Select
                    name="region"
                    value={formik.values.region}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="Region"
                  >
                    {regions.length === 0 ? (
                      <MenuItem disabled>No regions available</MenuItem>
                    ) : (
                      regions.map((region) => (
                        <MenuItem key={region.id} value={region.id}>
                          {region.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  {formik.touched.region && formik.errors.region && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {formik.errors.region}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={formik.touched.vehicleType && Boolean(formik.errors.vehicleType)}
                >
                  <InputLabel>Vehicle Type</InputLabel>
                  <Select
                    name="vehicleType"
                    value={formik.values.vehicleType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="Vehicle Type"
                  >
                    {services.length === 0 ? (
                      <MenuItem disabled>No services available. Please add services first.</MenuItem>
                    ) : (
                      services.map((service) => (
                        <MenuItem key={service.id} value={service.id}>
                          {service.service_name || service.name || 'Unnamed Service'}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  {formik.touched.vehicleType && formik.errors.vehicleType && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {formik.errors.vehicleType}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Vehicle Number"
                  name="vehicleNumber"
                  placeholder="KA 01 AB 1234"
                  value={formik.values.vehicleNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)}
                  helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Vehicle Model"
                  name="vehicleModel"
                  placeholder="Honda City"
                  value={formik.values.vehicleModel}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.vehicleModel && Boolean(formik.errors.vehicleModel)}
                  helperText={formik.touched.vehicleModel && formik.errors.vehicleModel}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={formik.touched.status && Boolean(formik.errors.status)}
                >
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="Status"
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="blocked">Blocked</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {formik.errors.status}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Bank Details Section */}
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }}>
                  <Chip 
                    label="Bank Details (Optional)" 
                    size="small" 
                    icon={<AccountBalance />}
                    sx={{ bgcolor: '#FFF3E0', color: '#E65100' }}
                  />
                </Divider>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bank Account Number"
                  name="bankAccountNumber"
                  placeholder="Enter account number"
                  value={formik.values.bankAccountNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.bankAccountNumber && Boolean(formik.errors.bankAccountNumber)}
                  helperText={formik.touched.bankAccountNumber && formik.errors.bankAccountNumber}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBalance sx={{ color: 'text.secondary' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="IFSC Code"
                  name="bankIfscCode"
                  placeholder="e.g., SBIN0001234"
                  value={formik.values.bankIfscCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.bankIfscCode && Boolean(formik.errors.bankIfscCode)}
                  helperText={formik.touched.bankIfscCode && formik.errors.bankIfscCode}
                  sx={{ textTransform: 'uppercase' }}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                />
              </Grid>

              {/* Bank Document Upload */}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Passbook / Cheque Image (Optional)
                  </Typography>
                  
                  {/* Document Preview */}
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    {bankDocumentPreview || (editMode && getExistingBankDetails().bankAccountImage && !bankDocumentPreview) ? (
                      <Box sx={{ position: 'relative' }}>
                        <img
                          src={
                            bankDocumentPreview ||
                            (editMode && getExistingBankDetails().bankAccountImage
                              ? `${config.SOCKET_URL}/${String(getExistingBankDetails().bankAccountImage).replace(/^\/+/, '')}`
                              : undefined)
                          }
                          alt="Bank document"
                          style={{
                            maxWidth: 300,
                            maxHeight: 150,
                            borderRadius: 4,
                            border: '1px solid #e0e0e0',
                            objectFit: 'cover',
                          }}
                        />
                        <IconButton
                          size="small"
                          sx={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            bgcolor: 'error.main',
                            color: 'white',
                            '&:hover': { bgcolor: 'error.dark' },
                          }}
                          onClick={handleRemoveBankDocument}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: 300,
                          height: 150,
                          border: '2px dashed #ccc',
                          borderRadius: 4,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: '#fafafa',
                        }}
                      >
                        <Typography variant="body2" color="text.secondary">
                          No document uploaded
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Upload Button */}
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<CloudUpload />}
                    sx={{
                      borderColor: '#FFC107',
                      color: '#000',
                      '&:hover': {
                        borderColor: '#FFD54F',
                        bgcolor: 'rgba(255, 193, 7, 0.1)',
                      },
                    }}
                  >
                    {bankDocumentPreview || (editMode && getExistingBankDetails().bankAccountImage) 
                      ? 'Change Document' 
                      : 'Upload Document'}
                    <input
                      id="bank-document-input"
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleBankDocumentChange}
                    />
                  </Button>
                  
                  {bankDocument && (
                    <Typography variant="caption" color="text.secondary">
                      {bankDocument.name} ({(bankDocument.size / 1024).toFixed(1)} KB)
                    </Typography>
                  )}
                  
                  {editMode && getExistingBankDetails().bankAccountImage && !bankDocumentPreview && (
                    <Typography variant="caption" color="text.secondary">
                      Current document will be kept unless you change it
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddDialog}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              disabled={formik.isSubmitting || isSubmitting}
              sx={{
                bgcolor: '#FFC107',
                color: '#000',
                '&:hover': {
                  bgcolor: '#FFD54F',
                },
              }}
            >
              {formik.isSubmitting || isSubmitting ? (
                <CircularProgress size={24} sx={{ color: '#000' }} />
              ) : (
                (editMode ? 'Update Driver' : 'Add Driver')
              )}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Assign Recharge Dialog */}
      <Dialog open={openRechargeDialog} onClose={handleCloseRechargeDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AccountBalanceWallet sx={{ color: '#FF9800' }} />
            Assign Recharge Plan
          </Box>
        </DialogTitle>
        <DialogContent>
          {rechargeDriver && (
            <Box sx={{ pt: 2 }}>
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {rechargeDriver.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {rechargeDriver.phone} • {rechargeDriver.vehicleType}
                </Typography>
              </Box>

              {driverRechargeStatus && (
                <Alert
                  severity={driverRechargeStatus.hasActiveRecharge ? 'success' : 'warning'}
                  sx={{ mb: 3 }}
                >
                  {driverRechargeStatus.hasActiveRecharge ? (
                    <>
                      Active recharge: {driverRechargeStatus.remainingDays} days remaining
                      <br />
                      <Typography variant="caption">
                        Expires: {new Date(driverRechargeStatus.subscriptionExpiry).toLocaleDateString()}
                      </Typography>
                    </>
                  ) : (
                    'No active recharge plan'
                  )}
                </Alert>
              )}

              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel>Select Recharge Plan</InputLabel>
                <Select
                  value={selectedPlanId}
                  onChange={(e) => {
                    setSelectedPlanId(e.target.value);
                    setCustomDays('');
                  }}
                  label="Select Recharge Plan"
                >
                  <MenuItem value="">
                    <em>-- Select a plan or enter custom days below --</em>
                  </MenuItem>
                  {rechargePlans.length === 0 ? (
                    <MenuItem disabled>No recharge plans available</MenuItem>
                  ) : (
                    rechargePlans.map((plan) => (
                      <MenuItem key={plan.id} value={plan.id}>
                        {plan.name || `${plan.days} Days`} - ₹{plan.price} ({plan.days} days)
                        {plan.service_name && ` • ${plan.service_name}`}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>

              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Box sx={{ flex: 1, height: 1, bgcolor: '#ddd' }} />
                <Typography sx={{ px: 2, color: 'text.secondary' }}>OR</Typography>
                <Box sx={{ flex: 1, height: 1, bgcolor: '#ddd' }} />
              </Box>

              <TextField
                fullWidth
                label="Custom Days (Free Assignment)"
                type="number"
                value={customDays}
                onChange={(e) => {
                  setCustomDays(e.target.value);
                  setSelectedPlanId('');
                }}
                placeholder="Enter number of days"
                inputProps={{ min: 1 }}
                sx={{ mb: 3 }}
                helperText="Enter custom days for free admin assignment"
              />

              <TextField
                fullWidth
                label="Notes (Optional)"
                value={rechargeNotes}
                onChange={(e) => setRechargeNotes(e.target.value)}
                placeholder="e.g., Promotional offer, Compensation, etc."
                multiline
                rows={2}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRechargeDialog}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAssignRecharge}
            disabled={rechargeLoading || (!selectedPlanId && !customDays)}
            sx={{
              bgcolor: '#FF9800',
              color: '#fff',
              '&:hover': {
                bgcolor: '#F57C00',
              },
            }}
          >
            {rechargeLoading ? 'Assigning...' : 'Assign Recharge'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DriversPage;